module.exports = __webpack_public_path__ + "static/media/klicksieger-logo.f118c1ce.jpg";